import { createContext } from "react";
import { ExtAContextTypes } from "../types/extendedA";

const ExtAContext = createContext<ExtAContextTypes | undefined>(undefined);

export default ExtAContext;
